import type { PropsWithChildren } from 'react';

import './success-story-card.scss';
import { getIsTouchDevice } from '../../../utils';

interface Props extends PropsWithChildren {
  imgUrl: string;
  imgAlt?: string;
}

export const SuccessStoryCard = ({ imgUrl, imgAlt, children }: Props) => {
  if (getIsTouchDevice()) {
    return (
      <div className="payflow-ui-success-story-card_touch">
        <div className="payflow-ui-success-story-card">
          <img src={imgUrl} alt={imgAlt} className="success-story-card__image" />
        </div>
        <div className="success-story-card__content">{children}</div>
      </div>
    );
  }

  return (
    <div className="payflow-ui-success-story-card">
      <img src={imgUrl} alt={imgAlt} className="success-story-card__image" />
      <div className="success-story-card__content">{children}</div>
    </div>
  );
};
